import CheckedSelectionState from "./CheckedSelectionState";
import BaseInitState from "../../BaseInitState";
import FactorBlock from "../FactorBlock.vue";

/** Etat initial pour le facteur */
export default class InitState extends BaseInitState<FactorBlock> {
    public constructor() {
		super();
	}
    
    /** 
     * Sur l'entrée dans l'etat
     * @param args Paramètres optionnels
     */
    public Enter(args?: any): void {
        super.Enter(args);
        console.debug("InitState - Benchmarking - Enter");
    }
    
    /** Sur sortie de l'état sur application
     * @param args Paramètres optionnels
     */
    public Next(args?: any): void {
        super.Next(args);

        console.debug("InitState - Benchmarking - Next");
        
        this.context.TransitionTo(new CheckedSelectionState());
    }

    /** Sur fermeture d'un etat */
    public Previous(args?: any): void {
        super.Next(args);

        console.debug("InitState - Benchmarking - Previous");
    }
}